const state = {
  userList: [],
  currentUser: null,
  loading: false
}

const mutations = {
  SET_USER_LIST(state, users) {
    state.userList = users
  },
  SET_CURRENT_USER(state, user) {
    state.currentUser = user
  },
  SET_LOADING(state, status) {
    state.loading = status
  }
}

const actions = {
  // 用户管理相关操作将在后续实现
}

const getters = {
  userList: state => state.userList,
  currentUser: state => state.currentUser,
  loading: state => state.loading
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
